module.exports = __webpack_public_path__ + "static/img/payewm.4775877.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payewm.jpg
// module id = Na1u
// module chunks = 2